import React from 'react';
import {
    getFeConfig,
    submitFCConfirmation,
    submitFCRefusal,
    getConfirmationInfo
} from "../api/api";
import {Form} from "@q4us-sw/q4us-ui";
import {FormElementProps} from "@q4us-sw/q4us-ui/lib/Form";
import {resolve} from "@q4us-sw/q4us-ui/lib/Cell";
import {Row, Col, Descriptions, notification} from 'antd';
import {Trans, withTranslation} from "react-i18next";
import {FormInstance} from "antd/lib/form/hooks/useForm";
import {unstable_batchedUpdates} from "react-dom";
import imgSrc from "../assets/easLogo.png";
import '../styles/restrictedIOSSSale.css'


interface Config {
    data: { statusCode: number, rows?: FormElementProps[] }
}

const RestrictedOSSSale = (props: any) => {

    const redirectURI : string = props.redirectURI;
    const declineURI : string = props.declineURI;
    const value : {[key: string] : any} = props.data;

    const [dD, seDDConfig] = React.useState([] as FormElementProps[])
    const [loading, setLoading] = React.useState(true)
    const [confirmationInfo, setConfirmationInfo] = React.useState<String>();


    const load = async () => {
        const dd = await getFeConfig('fc_confirmation_restricted_details') as Config;
        const confirmationRes = await getConfirmationInfo();

        unstable_batchedUpdates(() => {
            seDDConfig(dd.data.rows || [])
            setLoading(false)
            setConfirmationInfo(confirmationRes.data.value);
            props.setLoadedCb(false);
        })
    };

    React.useEffect(() => {
        load().catch(e => notification.warn({message: e.message}));
    }, []);

    return <React.Fragment>
        <Row>
            <Col>
                <img className="logo" src={imgSrc} alt="Logo"/>
            </Col>
        </Row>
        <div className="descriptions">
            <Descriptions layout="vertical" column={6} title={<div className="orderBreakdown">Order Amount Breakdown</div>} bordered>
                {
                    dD.map((o) => <Descriptions.Item
                        label={
                            <Trans
                                defaults={o.title}
                                i18nKey={`fc_restrictions_fe.${o.name}`}
                            />}
                        style={{backgroundColor: "white"}}>
                        {resolve({...o, value: value[o.name], schema: 'fc_restrictions_fe'})}
                    </Descriptions.Item>)
                }

                <Descriptions.Item> <Trans
                    i18nKey={`fc_restrictions_fe.${value.fcc_order_ioss_sale_over_threshold}`}
                    values={{delivery_region: value.fcc_delivery_region_name, country_threshold: value.fcc_delivery_country_threshold}}
                /> </Descriptions.Item>
            </Descriptions>
        </div>
        <div className={`form-wrap`}>

            {(!loading) && <Form
                schema={`fc_restrictions_fe`}
                acceptText={"Proceed with order > 150 EUR"}
                acceptTextValues={{country_threshold: value.fcc_delivery_country_threshold}}
                rejectText={"Return to cart"}
                initialValue={value}
                disableAccept={(value.fcc_order_ioss_sale_over_threshold === 'totally_restrict')}
                config={async (schema: string) => {
                    const res = await getFeConfig(schema) as Config;
                    return res.data.rows || [];
                }}

                submit={async (values: { [key: string]: any; }) => {

                    const {id = "", timestamp_year = ""} = value;
                    values = {id, redirectURI, timestamp_year, 'fcc_recipient_national_id': null, 'fcc_date_of_birth': null};

                    if (confirmationInfo !== 'no_confirmation') {
                        props.toggleShowFCConfirm();
                        return true;
                    } else {
                        const retVal = await submitFCConfirmation(values) || {};

                        const {status, data: {paymentURL}} = retVal;
                        if (status === 200) {
                            window.location.href = paymentURL;
                            return true;
                        } else {
                            return false;
                        }
                    }
                }}
                rejected={async () => {
                    const {id = "", timestamp_year = ""} = value;
                    submitFCRefusal({id, timestamp_year}).catch(e => notification.warn(e));

                    let declineRedirectURL = redirectURI;
                    if (declineURI) {
                        declineRedirectURL = declineURI;
                    }

                    window.location.href = `${declineRedirectURL}`;
                }}
                validateField={async (rule: any, _value: any, schema: string, column: FormElementProps, form: FormInstance<any>) => {}}
                visibilityValidator={(schema, {name}, form) => {
                    return false;

                }}/>}

        </div>
    </React.Fragment>
}


export const RestrictedOSSSaleElement = withTranslation()(RestrictedOSSSale)